/**
 * Viewing is removed (TMMAPP-0159 §A 1). Its pick lived in `localStorage` under `tmm_viewing`; the
 * shell drops a leftover once per page load, every access in try/catch.
 */
export const LEFTOVER_VIEWING_KEY = 'tmm_viewing';

let forgotten = false;

export function forgetLeftoverViewing(): void {
  if (forgotten) return;
  forgotten = true;
  try {
    localStorage.removeItem(LEFTOVER_VIEWING_KEY);
  } catch {
    /* localStorage unavailable: nothing to remove */
  }
}

/** Tests only: the next call removes again. */
export function resetLeftoverViewingForTests(): void {
  forgotten = false;
}
